<script lang='ts'>import { Popup } from 'framework7-svelte';
export let opened = false;
export let title = 'Instructions';
export let steps = [];
export let headerImage = '/static/images/instructions-header.png';
export let onClose;
let popup;
function close() {
    opened = false;
}
function handlePopupClosed() {
    close();
    if (onClose) {
        onClose();
    }
}
function formatStepNumber(index) {
    return String(index + 1).padStart(2, '0');
}
</script>

<Popup
  bind:this={popup}
  class={'instructions-popup'}
  backdropEl={'.instructions-popup-backdrop'}
  opened={opened}
  onPopupClosed={handlePopupClosed}
  closeByBackdropClick={true}
  closeOnEscape={true}
  tabletFullscreen={true}
>
  <div class="instructions-content">
    <button class="close-button" on:click={close}>✕</button>

    {#if headerImage}
      <img class="header-image" src={headerImage} alt="" />
    {/if}

    <div class="arrows">&gt;&gt;&gt;&gt;&gt;&gt;</div>
    <h2 class="title">{title}</h2>

    <div class="instructions-body">
      {#each steps as step, index}
        <div class="instruction-step">
          <div class="step-number">STEP {formatStepNumber(index)}:</div>
          <div class="step-title">{step.title}</div>
          <p class="step-description">{step.description}</p>
        </div>
      {/each}
    </div>
  </div>
</Popup>
<div class="popup-backdrop instructions-popup-backdrop" on:click={close}/>

<style>.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 12500;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}

:global(.instructions-popup.modal-in) ~ .popup-backdrop {
  opacity: 1;
  pointer-events: auto;
}

.instructions-content {
  position: relative;
  padding: 5cqw;
  background: linear-gradient(to bottom, #0f1743, #1a2456);
  height: 100%;
  overflow-y: auto;
}

.close-button {
  position: absolute;
  top: 5cqw;
  right: 5cqw;
  background: none;
  border: none;
  font-size: 8cqw;
  color: #FFCC00;
  cursor: pointer;
  padding: 0;
  width: 10cqw;
  height: 10cqw;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.header-image {
  display: block;
  width: 30cqw;
  height: auto;
  margin-bottom: 3cqw;
}

.arrows {
  font-size: 3cqw;
  color: #FFCC00;
  margin-bottom: 1cqw;
  letter-spacing: 0.1em;
  margin-left: 0.7cqw;
}

.title {
  font-size: 10cqw;
  font-weight: bold;
  color: white;
  margin: 0 0 5cqw 0;
  line-height: 1.1;
  text-transform: uppercase;
}

.instructions-body {
  display: flex;
  flex-direction: column;
  grid-gap: 3cqw;
  gap: 3cqw;
  padding-bottom: 5cqw;
}

.instruction-step {
  padding: 5cqw;
  background-color: white;
  border-radius: 20px;
}

.step-number {
  font-size: 4cqw;
  font-weight: bold;
  color: #283583;
  font-family: 'Roboto Mono', monospace;
  margin-bottom: 0.5cqw;
}

.step-title {
  font-size: 5cqw;
  font-weight: bold;
  color: #283583;
  text-transform: uppercase;
  font-family: 'Roboto Mono', monospace;
  margin-bottom: 2cqw;
}

.step-description {
  font-size: 3.5cqw;
  color: #333;
  margin: 0;
  line-height: 1.4;
}</style>
